import { HttpClient, HttpResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ResponseMessage } from '../model/FormsEntity/responseForOnlineBooking';
@Injectable({
providedIn: 'root'
})
export class DeptLoginService {
  private data: {};
  private usersUrl1:String =environment.baseUrl + 'DeptLogin/';
  constructor(private http:HttpClient ) {
 }

 

public Geteparichayurl() :Observable<HttpResponse<any>> { 
  return this.http.get<any>(this.usersUrl1+'deptLoginEparicay' , {observe: 'response' });
}
// public getConsumerDetail(data) : Observable<HttpResponse<any>> { 
//   return this.http.get<any>(this.usersUrl1 +'getConsumerDetail'+data, {observe: 'response' });
// }
// public getUnpaidBill(data) : Observable<HttpResponse<any>> { 
//   return this.http.get<any>(this.usersUrl1 +'searchUnPaidBill'+data, {observe: 'response' });
// }
// public searchPaidBill(data) : Observable<HttpResponse<any>> { 
//   return this.http.get<any>(this.usersUrl1 +'searchPaidBill'+data, {observe: 'response' });
// }
// public viewBill(data) : Observable<HttpResponse<any>> { 
//   return this.http.get<any>(this.usersUrl1 +'viewBill'+data, {observe: 'response' });
// }
//admin
//upload water bill


}
